/**
 * 计算音频文件的时长（秒）
 * @param {string} src - 音频文件的URL
 * @returns {Promise<number>} 音频时长（秒）
 */
export async function calculateAudioDuration(src: string): Promise<number> {
  return new Promise((resolve, reject) => {
    const audio = new Audio();

    // 当音频元数据加载完成时，可以获取时长
    audio.addEventListener('loadedmetadata', () => {
      if (!isNaN(audio.duration)) {
        resolve(audio.duration);
      } else {
        reject(new Error('无法获取音频时长'));
      }

      // 清理，避免内存泄漏
      audio.src = '';
      audio.removeEventListener('loadedmetadata', () => {});
    });

    // 处理加载错误
    audio.onerror = (error) => {
      reject(error);
      audio.src = '';
      audio.removeEventListener('error', () => {});
    };

    // 设置音频源触发加载
    audio.src = src;
  });
}
